export default "__VITE_ASSET__28ea38c1__"